module.exports = __webpack_public_path__ + "img/logo.887b15a3.jpg";